import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'


//constants
import { Constants }         from '../../constants/Constants';

import { CustomerGridComponent } from '../../components/Grids/CustomerGrid.component';


@Component({
  selector: 'my-customer-validation',
  templateUrl: './CustomerValidation.component.html'
})
export class CustomerValidationComponent implements OnInit {

    
    public displayDialog: boolean;

    @ViewChild(CustomerGridComponent) customerGridComponent: CustomerGridComponent;

    @Output() public yesClick: EventEmitter<any> = new EventEmitter();
    @Output() public cancelClick: EventEmitter<any> = new EventEmitter();

    constructor(private requestService: serv.RequestService) 
    {

    }

    setCustomers(customers: ent.Customer[]){
        this.customerGridComponent.records = customers;
    }


    ngOnInit(): void {
    }

    onHide(){
        this.displayDialog = false;
    }

    onCancelClick(event: any){
        this.cancelClick.emit(null);
        this.displayDialog = false;
    }

    onYesClick(event: any){
        this.yesClick.emit(null);
        this.displayDialog = false;
    }

}